import HeaderBar from "../../../components/header/headerBar";
import { SearchField } from "../../../components/textfield";
import MainButton from "../../../components/button/mainButton";
import IconMdi from "@mdi/react";
import { useHistory } from "react-router";
import "../../../assets/styles/admin/treatment.scss";
import { Icon } from "@iconify/react";
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Select,
  Input,
  Form,
  Checkbox,
  Radio,
  Button,
  Modal,
  Table,
} from "antd";
import { mdiPencilCircle, mdiMenuLeft, mdiTrashCanOutline } from "@mdi/js";
import { numberWithCommas } from "../../../helpers/functions";

const Treatment = () => {
  const { confirm } = Modal;

  const history = useHistory();

  const [treatmentList, setTreatmentList] = useState<any>([]);
  const [isModal, setIsModal] = useState(false);
  const [idTreatment, setIdTreatment] = useState<any>();

  const columns = [
    {
      title: "",
      dataIndex: "no",
      width: 50,
    },
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "Name",
      dataIndex: "name",
      width: 500,
    },
    {
      title: "Price (Local/Agency)",
      align: "center" as const,
      render: (record: any) => (
        <div>
          {numberWithCommas(record?.price?.normal?.coursePriceLocal, 0)}/
          {numberWithCommas(record?.price?.normal?.coursePriceAgency, 0)}
        </div>
      ),
    },
    {
      title: "",
      render: (record: any) => (
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <div
            style={{ cursor: "pointer" }}
            onClick={() =>
              history.push(`treatment/treatmentcreate/${record._id}`)
            }
          >
            <Icon icon="el:pencil-alt" color="#5baea9" width="20" height="20" />
          </div>
          <div>{record.quantity}</div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => showDeleteConfirm(record)}
          >
            <Icon
              icon="icomoon-free:bin"
              width="20"
              height="20"
              color="#FF6760"
            />
          </div>
        </div>
      ),
    },
  ];

  const getAPIs = async () => {
    const dataTreatment = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/treatments?page=1&search=`
    );
    let newData = dataTreatment.data.data;
    if (newData) {
      newData = newData.map((newData: any, index: number) => ({
        ...newData,
        no: index + 1,
      }));

      console.log("newData", newData);

      setTreatmentList(newData);
    }
  };

  const openModal = (id: any) => {
    setIsModal(true);
    setIdTreatment(id);
  };

  const handleCancel = () => {
    setIsModal(false);
  };

  const deleteTreatMent = async (id: any) => {
    // console.log("idTreatment", idTreatment);
    try {
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/treatments/${id}`);
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  function showDeleteConfirm(value: any) {
    confirm({
      title: "",
      content: (
        <>
          {console.log("value", value)}

          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${value.name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${value.name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteTreatMent(value?._id);
      },
      width: "fit-content",
    });
  }

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar title="TREATMENT LIST" />
      <div style={{ padding: "20px 40px" }}>
        <SearchField
          placeholder="Search for Treatment (Treatment Name, Code)"
          color="#fff"
        />
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            title="Export Item"
            to={`#`}
            className="mg-10"
            background="#FFF"
            color="#000000"
            border="1px solid #263544"
          ></MainButton>
          <MainButton
            title="Create Medical Treatment"
            onClick={() => history.push(`treatment/treatmentcreate/create`)}
            className="mg-10"
          ></MainButton>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table
            columns={columns}
            dataSource={treatmentList}
            pagination={false}
            rowKey="_id"
            bordered
          />
        </div>
      </div>

      <Modal
        visible={isModal}
        onOk={deleteTreatMent}
        onCancel={handleCancel}
        closable={false}
      >
        คุณต้องการลบข้อมูล TREATMENT หรือไม่
      </Modal>
    </div>
  );
};
export default Treatment;
